'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @fileOverview ReactComponent for displaying a collection of Days in a picker.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author jzetlen
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @memberof component-datepicker
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @function Days
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a collection of `<tr>` elements for use in a {@link Month} table.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The table rows are rendered one per week, and each row contains a collection
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of {@link Day} elements. Renders the month provided by the `showMonth` prop,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * and breaks up weeks according to the `startOfWeek` prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                **/

/**
 * Cheap function for creating a range of values, e.g. range(2) === [1,2]
 */
function range(total) {
	var out = [];
	while (total) {
		out.unshift(total--);
	}
	return out;
}

/**
 * @function Day
 * Renders a single day for use inside a collection of {@link Days}.
 * Day elements are `div` elements inside `td` elements. On each render, they
 * will have the following class names applied:
 *  - `day` for all days
 *  - the value of `props.className` plus the day number, e.g. `caldate23`
 *  - `valid` if the day is valid according to `props.validateDate`
 *  - `invalid` if the day is invalid according to `props.validateDate`
 *  - `toMonth` if the day is in the currently displaying month,  rather than
 *     in the trailing final days of the previous month or the leading days of
 *     the next month
 *  - `nextMonth` if the day is not in the currently displaying month _(though
 *    this classname will also apply to days in the previous month, for legacy
 *    compatibility reasons)_
 *  - `checked` if the day is between `props.startDate` and `props.endDate`
 *  - `date-selected` if the day is equal to `props.startDate` or
 *    `props.endDate`
 *  - `first-date-selected` if the day is equal to `props.startDate`
 *  - `last-date-selected` if the day is equal to `props.endDate`
 *  - `leftEdge` if the day begins the week
 *  - `rightEdge` if the day ends the week
 */

var Day = function (_Component) {
	_inherits(Day, _Component);

	function Day() {
		_classCallCheck(this, Day);

		return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
	}

	_createClass(Day, [{
		key: 'render',
		value: function render() {
			var props = this.props;
			var date = props.date;
			// put together a list of CSS classes for the day element, to be joined
			// with ' '
			var classList = ['day', props.dayClassName + props.dayNumber, props.isInMonth ? 'toMonth' : 'nextMonth', props.valid ? 'valid' : 'invalid'];
			if (props.checked) {
				classList.push('checked');
			}

			// add dynamic classnames based on this date's relation to the current
			// date range state
			var year = date.getFullYear(),
			    month = date.getMonth(),
			    dayOfWeek = date.getDay(),
			    endOfWeek = (props.startOfWeek + 6) % 7,
			    endOfMonth = new Date(year, month + 1, 0).getDate();
			if (props.dayNumber === 1 || dayOfWeek === props.startOfWeek) {
				classList.push('leftEdge');
			}
			if (dayOfWeek === endOfWeek || props.dayNumber === endOfMonth) {
				classList.push('rightEdge');
			}
			if (props.isStartDate) {
				classList.push('date-selected', 'first-date-selected');
			}
			if (props.isEndDate) {
				classList.push('date-selected', 'last-date-selected');
			}

			return _react2.default.createElement(
				'td',
				null,
				_react2.default.createElement(
					'div',
					{
						className: classList.join(' '),
						'data-day': props.dayNumber,
						onMouseOver: function onMouseOver(e) {
							return props.onHoverDay(e, props);
						},
						onClick: function onClick(e) {
							return props.onClickDay(e, props);
						} },
					props.dayNumber
				)
			);
		}
	}]);

	return Day;
}(_react.Component);

/**
 * Constant representing six arrays of ascending integers split by sevens.
 */


var sixWeeks = range(6).map(function (num) {
	return range(7).map(function (day) {
		return day + 7 * (num - 1);
	});
});
/**
 * Returns only the set of weeks from the above constant necessary to render
 * the current month. Some months need all six. February sometimes needs only
 * four.
 */
function getWeeksForMonth(year, month, offset) {
	var always = 3;
	var firstWeekNotRequired = sixWeeks.slice(always).findIndex(function (week) {
		var weekStart = new Date(year, month, week[0] - offset);
		return weekStart.getMonth() !== month;
	});
	if (firstWeekNotRequired === -1) {
		return sixWeeks;
	}
	return sixWeeks.slice(0, firstWeekNotRequired + always);
}

var Days = function (_Component2) {
	_inherits(Days, _Component2);

	function Days() {
		_classCallCheck(this, Days);

		return _possibleConstructorReturn(this, (Days.__proto__ || Object.getPrototypeOf(Days)).apply(this, arguments));
	}

	_createClass(Days, [{
		key: 'render',
		value: function render() {
			var props = this.props;
			// `offset` represents the number of days in the first week before the
			// month actually begins. the component will render the trailing days
			// from the previous month, but the current month needs to begin
			// counting at 1.
			var year = props.month.getFullYear(),
			    month = props.month.getMonth(),
			    firstDayOfMonth = new Date(year, month, 1).getDay(),
			    offset = ((firstDayOfMonth - props.startOfWeek) % 7 + 7) % 7;

			function isInRange(date) {
				var time = date.getTime();
				var startTime = props.startDate.getTime();
				var endTime = props.endDate.getTime();
				return time >= startTime && time <= endTime;
			}
			function isSameDate(date1, date2) {
				return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
			}

			return _react2.default.createElement(
				'tbody',
				null,
				getWeeksForMonth(year, month, offset).map(function (week, i) {
					return _react2.default.createElement(
						'tr',
						{ key: i },
						week.map(function (day) {
							// the `day` is indexed at the current set of weeks,
							// so it doesn't actually represent the date of the month.
							// subtract the `offset` established above to get
							// the day of the month.
							var thisDate = new Date(year, month, day - offset);
							var dayNumber = thisDate.getDate();
							return _react2.default.createElement(Day, {
								key: day,
								dayNumber: dayNumber,
								date: thisDate,
								isStartDate: isSameDate(thisDate, props.startDate),
								isEndDate: isSameDate(thisDate, props.endDate),
								isInMonth: thisDate.getMonth() === month,
								startOfWeek: props.startOfWeek,
								valid: props.validateDate(thisDate),
								checked: isInRange(thisDate),
								onHoverDay: props.onHoverDay,
								onClickDay: props.onClickDay,
								dayClassName: props.dayClassName
							});
						})
					);
				})
			);
		}
	}]);

	return Days;
}(_react.Component);

exports.default = Days;


Days.defaultProps = {
	validateDate: function validateDate() {
		return true;
	}
};


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/component-datepicker/dist/components/Days.js
// module id = 508
// module chunks = 0